import { useContext, useEffect, useRef } from "react";
import AnalyticsContext from "app/utils/analytics/AnalyticsContext";
import { buildCommonData, buildTagData } from "app/utils/analytics/buildTagData";
import { useLocation } from "react-router-dom";
import { datadogRum } from "@datadog/browser-rum";

// introduce useDatadog to send action to datadog without putting event in datalayer
export const useDatadog = () => {
	const { store = {} } = useContext(AnalyticsContext);
	const { pathname, search } = useLocation();

	// @see useAnalytics : la location est lue à l'appel, pas au rendu, pour ne pas figer
	// la page dans un handler mémoïsé
	const locationRef = useRef({ pathname, search });

	useEffect(() => {
		locationRef.current = { pathname, search };
	}, [pathname, search]);

	return {
		addAction: (eventName, payload = {}) => {
			const state = store.getState() || {};

			const commonData = buildCommonData({ state, ...locationRef.current });
			const { env } = commonData;

			const tagData = buildTagData({ eventName, payload, commonData });

			if (env?.includes("live")) {
				const { event, ...restTagData } = tagData;

				datadogRum.addAction(event, {
					...restTagData,
				});
			}
		},
	};
};
